import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TExtraCianSource } from '../../types/analytics/page';
import { IAnalyticsState } from '../../types/analytics/state';

const initialState: IAnalyticsState = {
  page: {
    pageType: 'Newbuilding_Finder_Form',
    siteType: 'desktop',
  },
  extra: {
    cianSource: undefined,
  },
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setExtraCianSource: (state, action: PayloadAction<TExtraCianSource>) => {
      state.extra.cianSource = action.payload;
    },
  },
});

export const {
  reducer: analyticsReducer,
  actions: { setExtraCianSource },
} = analyticsSlice;
